import { LOADING_BAR_HIDE, LOADING_BAR_SHOW } from './loadingBar.actions';

type LoadingBarState = { count: number };

const initialState: LoadingBarState = { count: 0 };

export default function loadingBarReducer(state = initialState, action: { type: string }): LoadingBarState {
    switch (action.type) {
        case LOADING_BAR_SHOW:
            return { count: state.count + 1 };
        case LOADING_BAR_HIDE:
            return { count: Math.max(0, state.count - 1) };
        default:
            return state;
    }
}
